export const mockAppraisalGuidelines = [
  {
    id: 'app-001',
    title: 'Fannie Mae Property Valuation Standards',
    description: 'Comprehensive guidelines for property valuation methods, comparable sales analysis, and market value determination for conventional loans.',
    source: 'Fannie Mae',
    category: 'Property Valuation',
    lastUpdated: '2024-01-15',
    tags: ['valuation', 'market value', 'comparable sales', 'appraisal methods'],
    url: '/guideline/app-001'
  },
  {
    id: 'app-002',
    title: 'FHA Appraisal Requirements and Standards',
    description: 'FHA minimum property standards, appraisal requirements, and property condition guidelines for FHA-insured loans.',
    source: 'HUD',
    category: 'Property Standards',
    lastUpdated: '2024-01-12',
    tags: ['FHA', 'minimum property standards', 'property condition', 'safety requirements'],
    url: '/guideline/app-002'
  },
  {
    id: 'app-003',
    title: 'VA Property Appraisal Guidelines',
    description: 'VA minimum property requirements, appraisal standards, and property condition requirements for VA-guaranteed loans.',
    source: 'VA',
    category: 'Property Standards',
    lastUpdated: '2024-01-10',
    tags: ['VA', 'minimum property requirements', 'appraisal standards', 'veteran loans'],
    url: '/guideline/app-003'
  },
  {
    id: 'app-004',
    title: 'Freddie Mac Appraisal Quality Standards',
    description: 'Quality control standards for appraisals, review requirements, and appraisal acceptance criteria for Freddie Mac loans.',
    source: 'Freddie Mac',
    category: 'Quality Control',
    lastUpdated: '2024-01-08',
    tags: ['quality control', 'appraisal review', 'acceptance criteria', 'standards'],
    url: '/guideline/app-004'
  },
  {
    id: 'app-005',
    title: 'Comparable Sales Selection and Analysis',
    description: 'Guidelines for selecting appropriate comparable sales, analyzing market data, and making adjustments for property differences.',
    source: 'Fannie Mae',
    category: 'Comparable Sales',
    lastUpdated: '2024-01-05',
    tags: ['comparable sales', 'market analysis', 'adjustments', 'property comparison'],
    url: '/guideline/app-005'
  },
  {
    id: 'app-006',
    title: 'Appraisal Review and Quality Control',
    description: 'Standards for reviewing appraisals, identifying deficiencies, and ensuring compliance with agency requirements.',
    source: 'HUD',
    category: 'Quality Control',
    lastUpdated: '2024-01-03',
    tags: ['appraisal review', 'quality control', 'deficiencies', 'compliance'],
    url: '/guideline/app-006'
  },
  {
    id: 'app-007',
    title: 'Property Condition Assessment Guidelines',
    description: 'Standards for assessing property condition, identifying required repairs, and determining property acceptability.',
    source: 'VA',
    category: 'Property Condition',
    lastUpdated: '2023-12-28',
    tags: ['property condition', 'repairs', 'assessment', 'acceptability'],
    url: '/guideline/app-007'
  },
  {
    id: 'app-008',
    title: 'Automated Valuation Model (AVM) Guidelines',
    description: 'Standards for using automated valuation models, when AVMs are acceptable, and quality control requirements.',
    source: 'Freddie Mac',
    category: 'Valuation Methods',
    lastUpdated: '2023-12-25',
    tags: ['AVM', 'automated valuation', 'technology', 'quality control'],
    url: '/guideline/app-008'
  },
  {
    id: 'app-009',
    title: 'Appraisal Waiver Guidelines',
    description: 'Criteria for appraisal waivers, property eligibility requirements, and risk assessment standards.',
    source: 'Fannie Mae',
    category: 'Appraisal Waivers',
    lastUpdated: '2023-12-22',
    tags: ['appraisal waiver', 'property eligibility', 'risk assessment', 'automated systems'],
    url: '/guideline/app-009'
  },
  {
    id: 'app-010',
    title: 'Condominium Appraisal Requirements',
    description: 'Special requirements for appraising condominium units, project review standards, and market analysis guidelines.',
    source: 'HUD',
    category: 'Property Types',
    lastUpdated: '2023-12-20',
    tags: ['condominium', 'project review', 'market analysis', 'unit appraisal'],
    url: '/guideline/app-010'
  },
  {
    id: 'app-011',
    title: 'Manufactured Housing Appraisal Standards',
    description: 'Guidelines for appraising manufactured homes, foundation requirements, and personal vs. real property classification.',
    source: 'VA',
    category: 'Property Types',
    lastUpdated: '2023-12-18',
    tags: ['manufactured housing', 'foundation requirements', 'property classification', 'mobile homes'],
    url: '/guideline/app-011'
  },
  {
    id: 'app-012',
    title: 'Rural Property Appraisal Guidelines',
    description: 'Special considerations for appraising rural properties, agricultural land valuation, and comparable sales challenges.',
    source: 'Freddie Mac',
    category: 'Property Types',
    lastUpdated: '2023-12-15',
    tags: ['rural property', 'agricultural land', 'comparable sales', 'special considerations'],
    url: '/guideline/app-012'
  },
  {
    id: 'app-013',
    title: 'Appraiser Independence Requirements',
    description: 'Standards for maintaining appraiser independence, prohibited practices, and compliance monitoring.',
    source: 'Fannie Mae',
    category: 'Compliance',
    lastUpdated: '2023-12-12',
    tags: ['appraiser independence', 'prohibited practices', 'compliance', 'ethics'],
    url: '/guideline/app-013'
  },
  {
    id: 'app-014',
    title: 'Desktop Appraisal Guidelines',
    description: 'Requirements for desktop appraisals, when they are acceptable, and quality control standards.',
    source: 'HUD',
    category: 'Appraisal Types',
    lastUpdated: '2023-12-10',
    tags: ['desktop appraisal', 'remote valuation', 'quality control', 'acceptable use'],
    url: '/guideline/app-014'
  },
  {
    id: 'app-015',
    title: 'Appraisal Form Requirements',
    description: 'Standards for completing appraisal forms, required documentation, and form-specific guidelines.',
    source: 'VA',
    category: 'Documentation',
    lastUpdated: '2023-12-08',
    tags: ['appraisal forms', 'documentation', 'completion standards', 'requirements'],
    url: '/guideline/app-015'
  },
  {
    id: 'app-016',
    title: 'Market Conditions Analysis',
    description: 'Guidelines for analyzing market conditions, identifying trends, and adjusting for market changes.',
    source: 'Freddie Mac',
    category: 'Market Analysis',
    lastUpdated: '2023-12-05',
    tags: ['market conditions', 'trend analysis', 'market adjustments', 'economic factors'],
    url: '/guideline/app-016'
  },
  {
    id: 'app-017',
    title: 'Appraisal Delivery and Timing Requirements',
    description: 'Standards for appraisal delivery, timing requirements, and coordination with loan processing.',
    source: 'Fannie Mae',
    category: 'Process Requirements',
    lastUpdated: '2023-12-03',
    tags: ['delivery requirements', 'timing standards', 'loan processing', 'coordination'],
    url: '/guideline/app-017'
  },
  {
    id: 'app-018',
    title: 'Appraisal Update and Recertification',
    description: 'Requirements for updating appraisals, recertification standards, and when updates are necessary.',
    source: 'HUD',
    category: 'Updates',
    lastUpdated: '2023-11-30',
    tags: ['appraisal updates', 'recertification', 'timing requirements', 'value changes'],
    url: '/guideline/app-018'
  }
];